import TopBar from './TopBar';

export default TopBar;


// WEBPACK FOOTER //
// ./src/components/TopBar/index.js